import { TTrackingUser } from '../../types/analytics';
import { IApplicationState } from '../../types/redux';

export function getTrackingUser(state: IApplicationState, regionId?: number | null): TTrackingUser {
  const { user } = state;

  if (user.isAuthenticated) {
    return {
      userId: user.userId,
      extra: {
        defaultRegionId: regionId,
      },
    };
  }

  return { extra: { defaultRegionId: regionId } };
}
